import { createElement, useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { newerBuildKey } from "@utils/appUpdate";

const enabled = !import.meta.env.DEV;
// meta.json of the build this tab loaded: the first one fetched.
let baseline = null;

const updateToast = () => createElement(
    "div",
    null,
    createElement("div", null, "Вышла новая версия"),
    createElement(
        "button",
        { type: "button", className: "btn btn-primary btn-sm", onClick: () => globalThis.location.reload() },
        "Обновить",
    ),
);

/**
 * Polls /meta.json and shows one persistent "new version" toast per detected build.
 * The first fetch is the baseline: VITE_BUILD_TIME / VITE_APP_VERSION come from CI
 * and never match what scripts/update-meta.mjs writes into meta.json.
 */
export const useAppUpdate = () => {
    const { data: key } = useQuery({
        queryKey: ["appMeta"],
        enabled,
        refetchInterval: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        queryFn: async () => {
            // Plain fetch on purpose: /meta.json is a same-origin static file, not the API.
            const res = await fetch("/meta.json", { cache: "no-store" });
            if (!res.ok) return null;
            const meta = await res.json();
            if (!baseline) baseline = meta;
            return newerBuildKey(baseline, meta);
        },
    });
    const shown = useRef(null);

    useEffect(() => {
        if (!key || shown.current === key) return;
        shown.current = key;
        toast(updateToast, { toastId: "app-update", autoClose: false, closeOnClick: false, draggable: false });
    }, [key]);
};
